import { h } from "preact";
import { useContext } from "preact/hooks";

import {Config} from "../../Store";
import styles from "./styles.scss";

const Route = props => {
    let { route } = props;
    let { formatAffected } = useContext(Config);
    let formatString = getFormatString(route, formatAffected);
    let formattedName = formatName(route, formatString);
    console.log(formattedName);
    return (
        <span>{addRouteLink(formattedName, route.route_url)}</span>
    );
}

const getFormatString = (route, formatAffected) => {
    let { route_id } = route;
    if ( route_id in formatAffected ) {
        return formatAffected[route_id];
    } else if ( "all" in formatAffected ) {
        return formatAffected["all"];
    } else {
        return "route_short_name: route_long_name";
    }
};

const formatName = (route, formatString) => {
    let {route_short_name, route_long_name} = route;
    formatString = formatString.replace("route_short_name", route_short_name);
    formatString = formatString.replace("route_long_name", route_long_name);
    // Assuming only one instance
    // let segments = formatString.split("route_circle");
    // if (segments.length > 1) {
    //     segments[1] = getRouteCircle(route);
    // }
    return formatString;
}

const getRouteCircle = route => {
    let { route_color, route_text_color, route_short_name } = route;
    return (
        <span
            class={styles.routeCircle}
            style={{backgroundColor: `#${route_color}`, color: `#${route_text_color}`}}
        >{route_short_name}</span>
    );
}

const addRouteLink = (routeString, url) => {
    if (url) {
        return (
            <a href={url}>{routeString}</a>
        );
    }
    return routeString;
}

export default Route;


// WEBPACK FOOTER //
// ./components/Alert/Route.js